import React from 'react';

export const allowOnlyNumbers = (event: React.KeyboardEvent): void => {
  if (event.ctrlKey || event.altKey || event.metaKey) {
    return;
  } else {
    const pressedKey = event.key;

    if (
      !/^\d$/.test(pressedKey) &&
      !['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Escape'].includes(pressedKey)
    ) {
      event.preventDefault();
    }
  }
};
